import ShButton from '@/components/Helpers/ShButton';

// @vue/component
export default {
  name: 'SmsHistorySearchPanel',

  components: {
    ShButton,
  },

  props: {
    statusList: {
      type: Array,
      default: () => [],
    },
    typeList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      searchParams: {
        number: '',
        type: '',
        status: '',
        send_time: null,
        delivered_time: null,
        src: '',
      }
    };
  },

  computed: {
    smsHeadersList() {
      return this.$store.getters['sms/headersList'];
    }
  },

  watch: {
    searchParams: {
      handler(newVal) {
        this.$emit('changeFilterBy', newVal);
      },
      deep: true,
    },
  },

  methods: {
    clearSearchParams() {
      this.searchParams.number = '';
      this.searchParams.type = '';
      this.searchParams.status = '';
      this.searchParams.send_time = null;
      this.searchParams.delivered_time = null;
      this.searchParams.src = '';
    }
  },
};
